export const destructiveActions = [
  'archived',
  'deleted',
  'failed',
  'removed',
  'reverted',
  'unapproved',
]
